import React from 'react';
import Slider from 'react-slick';

function Glpitem({ item, index, cls }) {
  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    arrow: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div
      className={`glpitem animate__animated animate__fadeInUp animate__delay-0${
        index + 1
      }s ${cls}`}
      key={index}>
      <div className="imgwrap">
        <Slider {...settings}>
          {item.images.map((i, index) => {
            return (
              <div className="imgbox" key={index}>
                <img src={i.img} alt="" />
                {i.imgtitle && <div className="title">{i.imgtitle}</div>}
              </div>
            );
          })}
        </Slider>
      </div>
      <div className="contbox">
        <div
          className="cont"
          dangerouslySetInnerHTML={{ __html: item.cont }}></div>
      </div>
    </div>
  );
}

export default Glpitem;
